import { render } from "./ceiling.vue?vue&type=template&id=b13bb600&scoped=true"
import script from "./ceiling.vue?vue&type=script&lang=ts"
export * from "./ceiling.vue?vue&type=script&lang=ts"

import "./ceiling.vue?vue&type=style&index=0&id=b13bb600&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b13bb600"

export default script